import store from "@/core/services/store";
import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";
import {
  UPDATE_PERSONAL_INFO,
  UPDATE_USER_DATA
} from "@/core/services/store/profile.module";
import { bus } from "@/main";
import BaseAuth from "@/components/General/Auth/baseAuth";

let url = process.env.VUE_APP_API_ADMIN;

class Auth {
  async login(authData, path = "/auth/login", resetUser = true) {
    if (resetUser) {
      this.resetUser();
      ApiService.setHeader();
    }
    let url = process.env.VUE_APP_API_ADMIN;

    let returnData = {
      success: false,
      data: ""
    };

    await ApiService.post(url + path, authData)
      .then(response => {
        returnData.success = true;
        returnData.data = response.data;
        returnData.meta = response.meta;
      })
      .catch(error => {
        returnData = {
          success: false,
          data: JSON.parse(error)
        };
      });

    if (returnData.success) {
      JwtService.saveToken(returnData.meta.token);
      ApiService.setHeader();
      await store.dispatch(UPDATE_USER_DATA, returnData.data);
      this.updateUserData(returnData.data);
    }
    return returnData;
  }

  async appLogin(accessToken) {
    this.resetUser();
    ApiService.setHeader();
    ApiService.setHeaderByKey("Authorization", "Bearer " + accessToken);
    return this.login({}, "/apps/login", false);
  }

  // Trade a refreshed host access token for a new Connect session (CONNECT-7724). The host token
  // rides only on this request: replacing the shared headers like appLogin would send it with
  // concurrent calls too. disableAbort: requests are deduplicated per URL, so the renewal must not
  // cancel an appLogin still in flight. background: a failed renewal is retried by the caller, so
  // it must neither log the user out nor stop the loading animations of other requests.
  async renewAppSession(accessToken) {
    const response = await ApiService.post(
      url + "/apps/login",
      {},
      { Authorization: `Bearer ${accessToken}` },
      false,
      true,
      [],
      true
    );
    if (!response?.meta?.token) {
      throw new Error("Session renewal returned no token");
    }
    JwtService.saveToken(response.meta.token);
    ApiService.setHeader();
  }

  verify() {
    let returnData = {
      success: false,
      user: "",
      token: ""
    };
    const token = JwtService.getToken();
    if (token) {
      returnData.token = token;
      returnData.success = true;
    } else {
      JwtService.destroyToken();
    }
    this.updateUserData();
    return returnData;
  }

  logout() {
    this.resetUser();
    BaseAuth.handleLogout();
    JwtService.destroyToken();
  }

  resetUser() {
    // reset user data
    localStorage.removeItem("selectedProjectData");
    ApiService.removeAllHeaders();
  }

  updateUserData(userData) {
    if (typeof userData === "undefined") {
      return;
    }
    userData.name = userData.core_data?.firstname ?? userData.name;
    userData.surname = userData.core_data?.lastname ?? "";

    store.dispatch(UPDATE_PERSONAL_INFO, userData);
    store.dispatch(UPDATE_USER_DATA, userData);
    bus.$emit("loggedIn", userData);
  }

  async twoFaCheck(authData) {
    return this.login(authData);
  }

  sendPasswordResetLink(data) {
    return ApiService.post(url + "/auth/password/email", data);
  }

  resetPassword(data) {
    return ApiService.post(url + "/auth/password/reset", data);
  }
}

export default new Auth();
